import React, { useState } from 'react';
import ViewProntuario from './Tabs/ViewProntuario';
import './Prontuario.css';

function Prontuario() {
  const [activeTab, setActiveTab] = useState('view');

  return (
    <div className="prontuario-container">
      <div className="prontuario-tabs">
        <button 
          className={`tab-button ${activeTab === 'view' ? 'active' : ''}`}
          onClick={() => setActiveTab('view')}
        >
          Prontuário Médico
        </button>
      </div>

      <ViewProntuario />
    </div>
  );
}

export default Prontuario; 